import { FiltersLayout, DateRangeFilter } from 'framework/list';
import { FC } from 'react';

const OtherSectionFilter: FC = () => {
  return (
    <FiltersLayout showAsIcon>
      <DateRangeFilter source="startDate" label="Period" canBeInFuture />
    </FiltersLayout>
  );
};

export default OtherSectionFilter;
